import { cn } from '@/lib/utils';

// Card-brand acceptance marks — Soap card-brand review requirement (Tyler Carlin).
//
// Brands confirmed from Soap's checkout: Visa, Mastercard, American Express.
// NO Discover — never show a mark for a brand we cannot process.
//
// Assets: /public/badges/cards/*.svg — uniform 780×500 acceptance marks
// (full-color marks on chip backgrounds) so all three render at equal visual
// weight. The chip treatment keeps each brand's color integrity on dark
// surfaces (brand guidelines prohibit recoloring the marks); rendered height
// is >= 24px (each brand's minimum) and the row gap provides clear space.
export function PaymentMarks({
  size = 'md',
  className,
}: {
  size?: 'sm' | 'md';
  className?: string;
}) {
  const h = size === 'sm' ? 'h-6' : 'h-8';
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <img src="/badges/cards/visa.svg" alt="Visa" className={cn(h, 'w-auto rounded-[4px]')} />
      <img src="/badges/cards/mastercard.svg" alt="Mastercard" className={cn(h, 'w-auto rounded-[4px]')} />
      <img src="/badges/cards/amex.svg" alt="American Express" className={cn(h, 'w-auto rounded-[4px]')} />
    </div>
  );
}
